import { Link } from 'react-router-dom'
import { colors } from '../design/tokens'

/**
 * El número de un documento, como link de verdad.
 *
 * Existe por el **click derecho**: para que el navegador ofrezca "abrir en
 * pestaña nueva" tiene que haber un `<a href>` abajo del cursor. Una fila que
 * navega por JavaScript no alcanza — no hay manejador que agregue opciones al
 * menú del navegador.
 *
 * Se dibuja igual que el texto de la celda (mismo color, sin subrayado) para no
 * ensuciar la tabla: lo que cambia es lo que puede hacer, no cómo se ve.
 */
export default function LinkDoc({ to, children, style = {} }) {
  return (
    <Link
      to={to}
      onClick={(e) => e.stopPropagation()}
      style={{ color: 'inherit', textDecoration: 'none', ...style }}
      title="Click derecho para abrirlo en una pestaña nueva"
      onMouseEnter={(e) => { e.currentTarget.style.color = colors.link }}
      onMouseLeave={(e) => { e.currentTarget.style.color = 'inherit' }}
    >
      {children}
    </Link>
  )
}
